export default __webpack_public_path__ + "static/media/error.3ba3c2fc.jpg";